import { Deserializable } from '../../../lib/models/deserializable';

export class ApplicantIncomeFromOutsideUK implements Deserializable {
  public ApplicantNumber?: number;
  public IncomeID: number;
  public IncomeCountryISOCode: string;
  public IncomePercentage?: number;

  deserialize(input: any): this {
    Object.assign(this, input);

    return this;
  }
}
